/* ==========================================================================
   QUESTION BANK — PART 5
   (a) NCLEX-PN and ATI Med-Surg PN — scope of practice differs from RN,
       so these cannot simply be shared with the RN tracks.
   (b) Additional visual items: science diagrams, experiment set-ups,
       and mathematical graphs/charts.
   ========================================================================== */
(function () {
  'use strict';

  if (!window.XP_BANK) window.XP_BANK = { items: [], stimuli: {} };
  var items = window.XP_BANK.items;

  var R = {
    statpearls: { t: 'StatPearls (NCBI Bookshelf)', u: 'https://www.ncbi.nlm.nih.gov/books/NBK430685/', k: 'scholarly' },
    ncsbn: { t: 'NCSBN — National Guidelines for Nursing Delegation', u: 'https://www.ncsbn.org/public-files/NGND-PosPaper_06.pdf', k: 'scholarly' },
    openstaxAP: { t: 'OpenStax — Anatomy & Physiology 2e', u: 'https://openstax.org/details/books/anatomy-and-physiology-2e', k: 'scholarly' },
    openstaxBio: { t: 'OpenStax — Biology 2e', u: 'https://openstax.org/details/books/biology-2e', k: 'scholarly' },
    openstaxChem: { t: 'OpenStax — Chemistry 2e', u: 'https://openstax.org/details/books/chemistry-2e', k: 'scholarly' },
    openstaxPhys: { t: 'OpenStax — College Physics 2e', u: 'https://openstax.org/details/books/college-physics-2e', k: 'scholarly' },
    openstaxAlg: { t: 'OpenStax — Elementary Algebra 2e', u: 'https://openstax.org/details/books/elementary-algebra-2e', k: 'scholarly' },
    openstaxStat: { t: 'OpenStax — Introductory Statistics', u: 'https://openstax.org/details/books/introductory-statistics', k: 'scholarly' },
    khan: { t: 'Khan Academy', u: 'https://www.khanacademy.org/math', k: 'reference' }
  };
  function yt(q, label) {
    return { t: label || ('YouTube — ' + q), u: 'https://www.youtube.com/results?search_query=' + encodeURIComponent(q), k: 'video' };
  }

  /* =====================================================================
     SVG helpers
     ===================================================================== */
  var S = '<svg viewBox="0 0 460 260" xmlns="http://www.w3.org/2000/svg" role="img">' +
    '<style>.t{font:700 12px sans-serif;fill:#1d2b2a}.l{font:600 11px sans-serif;fill:#1d2b2a}' +
    '.c{font:10px sans-serif;fill:#63807d}.w{font:600 11px sans-serif;fill:#fff}</style>';

  var svgScope =
    S + '<text class="t" x="230" y="18" text-anchor="middle">Who may do what</text>' +
    '<rect x="14" y="30" width="140" height="200" rx="8" fill="#f2faf8" stroke="#8fa3b0" stroke-width="2"/>' +
    '<rect x="14" y="30" width="140" height="26" rx="8" fill="#8fa3b0"/>' +
    '<text class="w" x="84" y="48" text-anchor="middle">UAP / CNA</text>' +
    '<text class="c" x="24" y="76">Vital signs</text><text class="c" x="24" y="94">Bathing, feeding</text>' +
    '<text class="c" x="24" y="112">Ambulating</text><text class="c" x="24" y="130">Intake &amp; output</text>' +
    '<text class="c" x="24" y="148">Positioning</text>' +
    '<text class="c" x="24" y="176" font-weight="700">Never:</text>' +
    '<text class="c" x="24" y="194">assess, teach,</text><text class="c" x="24" y="210">evaluate, medicate</text>' +
    '<rect x="162" y="30" width="140" height="200" rx="8" fill="#f2faf8" stroke="#1b7f52" stroke-width="2"/>' +
    '<rect x="162" y="30" width="140" height="26" rx="8" fill="#1b7f52"/>' +
    '<text class="w" x="232" y="48" text-anchor="middle">LPN / LVN</text>' +
    '<text class="c" x="172" y="76">Data collection</text><text class="c" x="172" y="94">Most medications</text>' +
    '<text class="c" x="172" y="112">Dressing changes</text><text class="c" x="172" y="130">Reinforce teaching</text>' +
    '<text class="c" x="172" y="148">Stable patients</text>' +
    '<text class="c" x="172" y="176" font-weight="700">Never:</text>' +
    '<text class="c" x="172" y="194">initial assessment,</text><text class="c" x="172" y="210">care plan, IV push*</text>' +
    '<rect x="310" y="30" width="136" height="200" rx="8" fill="#f2faf8" stroke="#004B49" stroke-width="2"/>' +
    '<rect x="310" y="30" width="136" height="26" rx="8" fill="#004B49"/>' +
    '<text class="w" x="378" y="48" text-anchor="middle">RN</text>' +
    '<text class="c" x="320" y="76">Initial assessment</text><text class="c" x="320" y="94">Care planning</text>' +
    '<text class="c" x="320" y="112">Evaluation</text><text class="c" x="320" y="130">Patient teaching</text>' +
    '<text class="c" x="320" y="148">Unstable patients</text>' +
    '<text class="c" x="320" y="176">Blood products</text><text class="c" x="320" y="194">Triage, delegation</text>' +
    '<text class="c" x="320" y="212">*varies by state</text>' +
    '</svg>';

  var svgTitration =
    S + '<text class="t" x="230" y="18" text-anchor="middle">Acid-base titration curve</text>' +
    '<line x1="60" y1="215" x2="430" y2="215" stroke="#1d2b2a" stroke-width="2"/>' +
    '<line x1="60" y1="215" x2="60" y2="35" stroke="#1d2b2a" stroke-width="2"/>' +
    '<text class="l" x="245" y="240" text-anchor="middle">Volume of NaOH added (mL)</text>' +
    '<text class="l" x="22" y="130" transform="rotate(-90 22 130)">pH</text>' +
    '<text class="c" x="52" y="219" text-anchor="end">0</text>' +
    '<text class="c" x="52" y="130" text-anchor="end">7</text>' +
    '<text class="c" x="52" y="45" text-anchor="end">14</text>' +
    '<line x1="60" y1="130" x2="430" y2="130" stroke="#c8e0de" stroke-dasharray="4 4"/>' +
    '<path d="M70 195 C130 188 170 178 200 168 C215 162 225 120 235 95 C242 78 260 70 300 64 C350 58 400 55 425 54" ' +
    'fill="none" stroke="#004B49" stroke-width="3"/>' +
    '<circle cx="232" cy="118" r="6" fill="#b3261e"/>' +
    '<text class="l" x="248" y="112" fill="#b3261e">Equivalence point</text>' +
    '<text class="c" x="248" y="126">moles acid = moles base</text>' +
    '<rect x="96" y="150" width="86" height="26" rx="5" fill="#fff8e1" stroke="#c9a227"/>' +
    '<text class="c" x="139" y="167" text-anchor="middle">buffer region</text>' +
    '<text class="c" x="139" y="188" text-anchor="middle">pH = pKa at half-way</text>' +
    '</svg>';

  var svgOsmosis =
    S + '<text class="t" x="230" y="18" text-anchor="middle">Red blood cells in three solutions</text>' +
    '<rect x="20" y="34" width="130" height="150" rx="8" fill="#eaf4ff" stroke="#3a7bd5" stroke-width="2"/>' +
    '<text class="l" x="85" y="54" text-anchor="middle">HYPOTONIC</text>' +
    '<circle cx="85" cy="112" r="38" fill="#ff8a8a" stroke="#b3261e" stroke-width="2"/>' +
    '<path d="M85 74 L85 60 M85 150 L85 164 M47 112 L33 112 M123 112 L137 112" stroke="#3a7bd5" stroke-width="2.5"/>' +
    '<text class="c" x="85" y="200" text-anchor="middle">Water enters.</text>' +
    '<text class="c" x="85" y="215" text-anchor="middle">Cell swells, may lyse.</text>' +
    '<rect x="164" y="34" width="130" height="150" rx="8" fill="#f2faf8" stroke="#1b7f52" stroke-width="2"/>' +
    '<text class="l" x="229" y="54" text-anchor="middle">ISOTONIC</text>' +
    '<circle cx="229" cy="112" r="28" fill="#e05a5a" stroke="#b3261e" stroke-width="2"/>' +
    '<circle cx="229" cy="112" r="11" fill="#f2faf8"/>' +
    '<text class="c" x="229" y="200" text-anchor="middle">No net movement.</text>' +
    '<text class="c" x="229" y="215" text-anchor="middle">Normal biconcave shape.</text>' +
    '<rect x="308" y="34" width="138" height="150" rx="8" fill="#fdf2f4" stroke="#b3261e" stroke-width="2"/>' +
    '<text class="l" x="377" y="54" text-anchor="middle">HYPERTONIC</text>' +
    '<path d="M377 88 q16 4 20 16 q10 4 6 16 q6 12 -8 16 q-6 12 -18 8 q-12 6 -20 -6 q-14 -2 -12 -16 q-8 -12 4 -20 q4 -14 18 -14 z" ' +
    'fill="#c94a4a" stroke="#8d1a14" stroke-width="2"/>' +
    '<path d="M377 70 L377 84 M339 112 L325 112 M415 112 L429 112" stroke="#b3261e" stroke-width="2.5"/>' +
    '<text class="c" x="377" y="200" text-anchor="middle">Water leaves.</text>' +
    '<text class="c" x="377" y="215" text-anchor="middle">Cell crenates (shrinks).</text>' +
    '</svg>';

  var svgEnzymeExpt =
    S + '<text class="t" x="230" y="18" text-anchor="middle">Enzyme activity against temperature</text>' +
    '<line x1="62" y1="205" x2="430" y2="205" stroke="#1d2b2a" stroke-width="2"/>' +
    '<line x1="62" y1="205" x2="62" y2="38" stroke="#1d2b2a" stroke-width="2"/>' +
    '<text class="l" x="246" y="232" text-anchor="middle">Temperature (\u00b0C)</text>' +
    '<text class="l" x="24" y="128" transform="rotate(-90 24 128)">Rate of reaction</text>' +
    '<path d="M70 200 C110 192 140 168 175 122 C195 96 205 72 220 66 C236 60 248 78 262 108 C274 134 290 178 310 198 C318 203 326 204 335 204" ' +
    'fill="none" stroke="#1b7f52" stroke-width="3"/>' +
    '<line x1="220" y1="66" x2="220" y2="205" stroke="#c9a227" stroke-dasharray="4 4" stroke-width="2"/>' +
    '<circle cx="220" cy="66" r="6" fill="#c9a227"/>' +
    '<text class="l" x="228" y="58" fill="#9a6700">Optimum \u2248 37 \u00b0C</text>' +
    '<text class="c" x="112" y="176">rate rises with</text>' +
    '<text class="c" x="112" y="190">kinetic energy</text>' +
    '<text class="c" x="330" y="150">denaturation \u2014</text>' +
    '<text class="c" x="330" y="164">active site lost,</text>' +
    '<text class="c" x="330" y="178">irreversible</text>' +
    '<text class="c" x="66" y="219">0</text><text class="c" x="216" y="219">37</text><text class="c" x="330" y="219">60</text>' +
    '</svg>';

  var svgLinear =
    S + '<text class="t" x="230" y="18" text-anchor="middle">y = 2x + 1 \u2014 slope and intercept</text>' +
    '<g stroke="#dceceb" stroke-width="1">' +
    '<line x1="90" y1="40" x2="90" y2="220"/><line x1="130" y1="40" x2="130" y2="220"/>' +
    '<line x1="170" y1="40" x2="170" y2="220"/><line x1="250" y1="40" x2="250" y2="220"/>' +
    '<line x1="290" y1="40" x2="290" y2="220"/><line x1="330" y1="40" x2="330" y2="220"/>' +
    '<line x1="50" y1="60" x2="370" y2="60"/><line x1="50" y1="100" x2="370" y2="100"/>' +
    '<line x1="50" y1="180" x2="370" y2="180"/><line x1="50" y1="220" x2="370" y2="220"/>' +
    '</g>' +
    '<line x1="50" y1="140" x2="378" y2="140" stroke="#1d2b2a" stroke-width="2"/>' +
    '<line x1="210" y1="34" x2="210" y2="228" stroke="#1d2b2a" stroke-width="2"/>' +
    '<text class="c" x="382" y="144">x</text><text class="c" x="214" y="32">y</text>' +
    '<line x1="110" y1="240" x2="110" y2="240" stroke="none"/>' +
    '<line x1="105" y1="230" x2="340" y2="40" stroke="#004B49" stroke-width="3"/>' +
    '<circle cx="210" cy="120" r="6" fill="#c9a227"/>' +
    '<text class="l" x="220" y="112" fill="#9a6700">y-intercept (0, 1)</text>' +
    '<path d="M250 100 H290" stroke="#b3261e" stroke-width="2"/>' +
    '<path d="M290 100 V60" stroke="#b3261e" stroke-width="2"/>' +
    '<text class="c" x="262" y="116" fill="#b3261e">run = 1</text>' +
    '<text class="c" x="296" y="84" fill="#b3261e">rise = 2</text>' +
    '<text class="l" x="300" y="212">slope = rise/run = 2</text>' +
    '</svg>';

  var svgNormal =
    S + '<text class="t" x="230" y="18" text-anchor="middle">The normal distribution \u2014 68 / 95 / 99.7</text>' +
    '<path d="M40 200 C100 200 110 40 230 40 C350 40 360 200 420 200" fill="#eaf4f3" stroke="#004B49" stroke-width="3"/>' +
    '<line x1="40" y1="200" x2="425" y2="200" stroke="#1d2b2a" stroke-width="2"/>' +
    '<line x1="230" y1="46" x2="230" y2="200" stroke="#b3261e" stroke-width="2"/>' +
    '<text class="c" x="230" y="216" text-anchor="middle">\u03bc</text>' +
    '<line x1="168" y1="96" x2="168" y2="200" stroke="#63807d" stroke-dasharray="3 3"/>' +
    '<line x1="292" y1="96" x2="292" y2="200" stroke="#63807d" stroke-dasharray="3 3"/>' +
    '<text class="c" x="168" y="216" text-anchor="middle">-1\u03c3</text>' +
    '<text class="c" x="292" y="216" text-anchor="middle">+1\u03c3</text>' +
    '<line x1="112" y1="150" x2="112" y2="200" stroke="#63807d" stroke-dasharray="3 3"/>' +
    '<line x1="348" y1="150" x2="348" y2="200" stroke="#63807d" stroke-dasharray="3 3"/>' +
    '<text class="c" x="112" y="216" text-anchor="middle">-2\u03c3</text>' +
    '<text class="c" x="348" y="216" text-anchor="middle">+2\u03c3</text>' +
    '<text class="l" x="230" y="128" text-anchor="middle">68%</text>' +
    '<path d="M172 138 H288" stroke="#004B49" stroke-width="1.5"/>' +
    '<text class="l" x="230" y="170" text-anchor="middle">95%</text>' +
    '<path d="M116 180 H344" stroke="#004B49" stroke-width="1.5"/>' +
    '</svg>';

  var svgBar =
    S + '<text class="t" x="230" y="18" text-anchor="middle">Reading the bar chart</text>' +
    '<line x1="62" y1="200" x2="430" y2="200" stroke="#1d2b2a" stroke-width="2"/>' +
    '<line x1="62" y1="200" x2="62" y2="36" stroke="#1d2b2a" stroke-width="2"/>' +
    '<g stroke="#dceceb"><line x1="62" y1="160" x2="430" y2="160"/><line x1="62" y1="120" x2="430" y2="120"/>' +
    '<line x1="62" y1="80" x2="430" y2="80"/><line x1="62" y1="40" x2="430" y2="40"/></g>' +
    '<text class="c" x="56" y="204" text-anchor="end">0</text><text class="c" x="56" y="164" text-anchor="end">10</text>' +
    '<text class="c" x="56" y="124" text-anchor="end">20</text><text class="c" x="56" y="84" text-anchor="end">30</text>' +
    '<text class="c" x="56" y="44" text-anchor="end">40</text>' +
    '<rect x="88" y="120" width="52" height="80" fill="#004B49"/><text class="c" x="114" y="216" text-anchor="middle">Mon</text>' +
    '<text class="l" x="114" y="112" text-anchor="middle">20</text>' +
    '<rect x="160" y="60" width="52" height="140" fill="#0a5c58"/><text class="c" x="186" y="216" text-anchor="middle">Tue</text>' +
    '<text class="l" x="186" y="52" text-anchor="middle">35</text>' +
    '<rect x="232" y="140" width="52" height="60" fill="#12706b"/><text class="c" x="258" y="216" text-anchor="middle">Wed</text>' +
    '<text class="l" x="258" y="132" text-anchor="middle">15</text>' +
    '<rect x="304" y="100" width="52" height="100" fill="#c9a227"/><text class="c" x="330" y="216" text-anchor="middle">Thu</text>' +
    '<text class="l" x="330" y="92" text-anchor="middle">25</text>' +
    '<rect x="376" y="160" width="46" height="40" fill="#8fa3b0"/><text class="c" x="399" y="216" text-anchor="middle">Fri</text>' +
    '<text class="l" x="399" y="152" text-anchor="middle">10</text>' +
    '<text class="l" x="24" y="130" transform="rotate(-90 24 130)">Units sold</text>' +
    '</svg>';

  var svgLever =
    S + '<text class="t" x="230" y="18" text-anchor="middle">Moments about a pivot</text>' +
    '<rect x="70" y="120" width="320" height="12" rx="3" fill="#b8ada0"/>' +
    '<path d="M230 132 L206 186 L254 186 Z" fill="#63807d"/>' +
    '<line x1="230" y1="132" x2="230" y2="100" stroke="#63807d" stroke-dasharray="3 3"/>' +
    '<rect x="96" y="76" width="52" height="44" rx="4" fill="#004B49"/>' +
    '<text class="w" x="122" y="103" text-anchor="middle">40 N</text>' +
    '<rect x="330" y="86" width="42" height="34" rx="4" fill="#c9a227"/>' +
    '<text class="l" x="351" y="108" text-anchor="middle">?</text>' +
    '<path d="M122 200 H230" stroke="#b3261e" stroke-width="2"/>' +
    '<text class="c" x="176" y="216" text-anchor="middle" fill="#b3261e">3.0 m</text>' +
    '<path d="M230 200 H351" stroke="#1b7f52" stroke-width="2"/>' +
    '<text class="c" x="290" y="216" text-anchor="middle" fill="#1b7f52">2.0 m</text>' +
    '<text class="c" x="230" y="244" text-anchor="middle">Balanced when clockwise moment = anticlockwise moment</text>' +
    '</svg>';

  /* =====================================================================
     (a) NCLEX-PN
     ===================================================================== */
  items.push(
    {
      id: 'nclexpn-cc-01', exam: 'nclex-pn', section: 'coordinated-care', difficulty: 'hard', type: 'mcq',
      q: 'A charge nurse is assigning tasks. Which is OUTSIDE the scope of a licensed practical nurse?',
      opts: [
        'Administering an oral antihypertensive to a stable client',
        'Performing the admission assessment on a newly arrived client',
        'Changing a sterile dressing on a healing surgical wound',
        'Reinforcing teaching about crutch use that the RN already delivered'
      ],
      a: 1,
      why: '<p>The <strong>initial admission assessment</strong> is an RN function and cannot be delegated to an LPN/LVN. The LPN performs <em>data collection</em> — gathering and reporting findings — but the RN performs the assessment, forms the nursing diagnosis and builds the care plan.</p>' +
        '<p>The other three are squarely within LPN scope: routine oral medications for a stable client, sterile dressing changes, and <em>reinforcing</em> teaching the RN has already given.</p>' +
        '<p>The single word that decides most of these items is the verb. <strong>Assess, plan, evaluate and teach stay with the RN.</strong> Collect, reinforce, administer and monitor may go to the LPN.</p>',
      visual: svgScope, caption: 'Scope by role. Verbs decide: assess/plan/evaluate/teach are RN-only.',
      refs: [R.ncsbn, yt('LPN vs RN scope of practice NCLEX delegation', 'Video — LPN versus RN scope')]
    },
    {
      id: 'nclexpn-cc-02', exam: 'nclex-pn', section: 'coordinated-care', difficulty: 'moderate', type: 'mcq',
      q: 'An LPN notes that a client\'s condition has changed significantly since the morning. The LPN should FIRST:',
      opts: [
        'Revise the nursing care plan to reflect the change',
        'Report the findings to the supervising registered nurse',
        'Contact the healthcare provider directly for new orders',
        'Document the change and continue with scheduled care'
      ],
      a: 1,
      why: '<p>The LPN collects data and <strong>reports to the supervising RN</strong>. Revising the care plan is an RN function, and going straight to the provider bypasses the chain of communication the RN is accountable for.</p>' +
        '<p>Documentation is necessary but is not the first action when a client\'s status has changed — reporting is, because it triggers reassessment.</p>' +
        '<p>The general pattern for PN items: when a client deteriorates, the LPN\'s correct action is almost always to <em>notify the RN</em>, not to independently decide or escalate past them.</p>',
      refs: [R.ncsbn, R.statpearls]
    },
    {
      id: 'nclexpn-si-01', exam: 'nclex-pn', section: 'safety-infection', difficulty: 'moderate', type: 'mcq',
      q: 'Before administering a medication, the LPN notes the dose ordered is twice the usual adult dose. The LPN should:',
      opts: [
        'Give half the ordered dose and document the reason',
        'Administer as ordered, since the provider prescribed it',
        'Hold the medication and clarify the order before giving it',
        'Ask another LPN to verify and then administer'
      ],
      a: 2,
      why: '<p>A nurse who administers a medication is accountable for it, regardless of who wrote the order. An unusual dose must be <strong>held and clarified</strong> before administration.</p>' +
        '<p>Giving a self-adjusted dose (option A) is practising outside scope — the nurse does not have prescriptive authority. Administering because a provider ordered it (B) does not transfer liability. A second LPN verifying (D) confirms the transcription, not the appropriateness.</p>' +
        '<p>The governing principle: <strong>you can always safely hold and ask.</strong> You can never safely give a dose you believe is wrong.</p>',
      refs: [R.statpearls, yt('nurse questioning medication order safety NCLEX', 'Video — Questioning an unsafe order')]
    },
    {
      id: 'nclexpn-phys-01', exam: 'nclex-pn', section: 'physiological', difficulty: 'moderate', type: 'mcq',
      q: 'A client with a nasogastric tube for feeding should be positioned:',
      opts: [
        'Flat on the back during and after feeding',
        'Head of bed elevated 30 to 45 degrees during and for 30 to 60 minutes after',
        'Left lateral with the head of bed flat',
        'Prone during feeding to promote gastric emptying'
      ],
      a: 1,
      why: '<p>Elevating the head of the bed <strong>30 to 45 degrees</strong> uses gravity to keep formula in the stomach and is the primary defence against <strong>aspiration</strong> — the most serious complication of enteral feeding.</p>' +
        '<p>Maintaining the elevation for 30 to 60 minutes after the feed matters as much as during it, because gastric emptying is not instant.</p>' +
        '<p>Also verify placement before each feed and check residual volume per facility policy. Lying flat during or straight after a feed is the classic wrong answer.</p>',
      refs: [R.statpearls, yt('NG tube feeding position aspiration prevention nursing', 'Video — Preventing aspiration in tube feeding')]
    },
    {
      id: 'nclexpn-hp-01', exam: 'nclex-pn', section: 'health-promo', difficulty: 'moderate', type: 'mcq',
      q: 'Which finding in a 6-month-old infant should the nurse report as a possible developmental concern?',
      opts: [
        'Rolling from back to front',
        'Absence of a social smile',
        'Bringing objects to the mouth',
        'Babbling with consonant sounds'
      ],
      a: 1,
      why: '<p>The <strong>social smile</strong> normally appears by <strong>2 months</strong>. Its absence at 6 months is a red flag warranting referral.</p>' +
        '<p>The other three are expected at or before 6 months: rolling back-to-front around 4 to 6 months, mouthing objects from about 4 months, and babbling with consonants from around 6 months.</p>' +
        '<p>These items reward knowing what should <em>already</em> have happened, not just what is coming next.</p>',
      refs: [{ t: 'CDC — Developmental Milestones', u: 'https://www.cdc.gov/ncbddd/actearly/milestones/index.html', k: 'scholarly' }]
    },

    /* ---- ATI Med-Surg PN ---- */
    {
      id: 'atimspn-01', exam: 'ati-med-surg-pn', section: 'scope', difficulty: 'hard', type: 'mcq',
      q: 'An LPN is caring for a post-operative client on a medical-surgical unit. Which action requires the RN rather than the LPN?',
      opts: [
        'Measuring and recording wound drainage output',
        'Evaluating whether the pain management plan has been effective',
        'Administering a scheduled oral analgesic',
        'Assisting the client to ambulate for the first time with a gait belt'
      ],
      a: 1,
      why: '<p><strong>Evaluation</strong> — judging whether an intervention achieved its goal — is an RN function and the final step of the nursing process. The LPN contributes the data that informs it.</p>' +
        '<p>Measuring drainage is data collection, giving a scheduled oral analgesic is within LPN scope, and assisting first ambulation is a standard task provided the client is stable.</p>' +
        '<p>Watch for the verb, not the difficulty of the task. First ambulation <em>sounds</em> riskier than evaluating pain relief, but scope is defined by the type of nursing judgement required.</p>',
      visual: svgScope, caption: 'Scope by role — the verb in the stem decides the answer.',
      refs: [R.ncsbn]
    },
    {
      id: 'atimspn-02', exam: 'ati-med-surg-pn', section: 'cardio', difficulty: 'moderate', type: 'mcq',
      q: 'An LPN collects data on a client with heart failure and finds a 1.4 kg weight gain since yesterday. The LPN should:',
      opts: [
        'Record it and recheck tomorrow',
        'Report it to the RN promptly',
        'Restrict the client\'s fluids immediately',
        'Administer an extra dose of the prescribed diuretic'
      ],
      a: 1,
      why: '<p>A gain of more than <strong>1 kg in 24 hours</strong> signals fluid retention and possible decompensation. Daily weight is the single most sensitive indicator of fluid status in heart failure — far more so than oedema, which appears only after several litres have accumulated.</p>' +
        '<p>The LPN\'s correct action is to <strong>report promptly to the RN</strong>. Restricting fluids or adjusting a diuretic dose independently is prescribing, which is outside scope.</p>' +
        '<p>Waiting until tomorrow misses the window in which the change is easily corrected.</p>',
      refs: [R.statpearls, yt('daily weight heart failure fluid overload nursing', 'Video — Daily weights in heart failure')]
    },
    {
      id: 'atimspn-03', exam: 'ati-med-surg-pn', section: 'resp', difficulty: 'moderate', type: 'mcq',
      q: 'A client with COPD is receiving oxygen. Which delivery setting is generally appropriate for this client?',
      opts: [
        'Nasal cannula at 2 L/min, titrated to the prescribed saturation target',
        'Non-rebreather mask at 15 L/min as a routine measure',
        'Simple face mask at 10 L/min continuously',
        'Room air only, since oxygen is contraindicated in COPD'
      ],
      a: 0,
      why: '<p>Clients with COPD are generally started on <strong>low-flow oxygen</strong> — commonly 1 to 3 L/min by nasal cannula — and titrated to a prescribed target saturation, often 88 to 92% rather than the usual 94 to 98%.</p>' +
        '<p>The reason is that some clients with chronic CO₂ retention depend partly on hypoxic drive; high-flow oxygen can blunt it and worsen hypercapnia. That is a reason for <em>careful titration and monitoring</em>, not for withholding oxygen — option D is dangerous.</p>' +
        '<p>High-flow devices remain correct in acute severe hypoxaemia; the exam is testing the routine case.</p>',
      refs: [R.statpearls, yt('COPD oxygen therapy target saturation hypoxic drive', 'Video — Oxygen targets in COPD')]
    },

    /* =====================================================================
       (b) ADDITIONAL VISUAL ITEMS — science experiments
       ===================================================================== */
    {
      id: 'vis-osmosis-01', exam: 'ati-teas', section: 'science', difficulty: 'hard', type: 'mcq',
      q: 'Red blood cells are placed in a solution and are observed to swell and burst. The solution was:',
      opts: ['Hypertonic to the cells', 'Isotonic to the cells', 'Hypotonic to the cells', 'Saturated with sodium chloride'],
      a: 2,
      why: '<p>Water moves by osmosis from where solute concentration is <em>lower</em> toward where it is <em>higher</em>. A <strong>hypotonic</strong> solution has less solute than the cell interior, so water flows <strong>into</strong> the cell — it swells and eventually lyses.</p>' +
        '<p>A hypertonic solution does the reverse: water leaves and the cell crenates. An isotonic solution produces no net movement, which is why 0.9% saline is the standard IV fluid.</p>' +
        '<p>The direction is easy to lose under pressure. Anchor it on: <strong>water chases salt.</strong></p>',
      visual: svgOsmosis, caption: 'The same red cell in hypotonic, isotonic and hypertonic surroundings.',
      refs: [R.openstaxBio, yt('osmosis tonicity red blood cells hypotonic hypertonic', 'Video — Tonicity and red blood cells')]
    },
    {
      id: 'vis-enzyme-01', exam: 'hesi', section: 'biology', difficulty: 'hard', type: 'mcq',
      q: 'In an experiment, enzyme activity rises steadily to 37 °C, then falls sharply and does not recover when the temperature is lowered again. This is because:',
      opts: [
        'The substrate was fully consumed at the peak',
        'The enzyme denatured, permanently losing its active site shape',
        'The reaction reached chemical equilibrium',
        'The enzyme was competitively inhibited by a product'
      ],
      a: 1,
      why: '<p>The irreversibility is the clue. Rising temperature increases molecular kinetic energy and therefore collision frequency, so the rate climbs. Past the optimum, heat breaks the hydrogen and ionic bonds holding the tertiary structure and the <strong>active site loses its shape</strong>.</p>' +
        '<p><strong>Denaturation is permanent</strong> — cooling does not refold the protein, which is exactly what the experiment demonstrates.</p>' +
        '<p>Substrate depletion, equilibrium and inhibition would all show different patterns, and none of them would be irreversible on cooling.</p>',
      visual: svgEnzymeExpt, caption: 'Rate rises with kinetic energy, peaks at the optimum, then collapses as the enzyme denatures.',
      refs: [R.openstaxBio, yt('enzyme temperature denaturation experiment graph', 'Video — Temperature and enzyme activity')]
    },
    {
      id: 'vis-titration-01', exam: 'hesi', section: 'chemistry', difficulty: 'advanced', type: 'mcq',
      q: 'On the titration curve of a weak acid with a strong base, the pH at the half-equivalence point is equal to:',
      opts: ['7.00 in all cases', 'The pKa of the weak acid', 'The pH at the equivalence point', 'The pKb of the conjugate base'],
      a: 1,
      why: '<p>At the <strong>half-equivalence point</strong>, exactly half the weak acid has been converted to its conjugate base, so [HA] = [A⁻].</p>' +
        '<p>Substituting into Henderson–Hasselbalch: pH = pKa + log(1) = <strong>pKa</strong>. This is the standard laboratory method for determining an unknown acid\'s pKa, and it is also the point of maximum buffering.</p>' +
        '<p>Note the equivalence point of a weak acid with a strong base is <em>above</em> 7, not at it, because the conjugate base left in solution is itself basic. Only a strong acid with a strong base gives exactly 7.</p>',
      visual: svgTitration, caption: 'Buffer region, half-equivalence (pH = pKa) and the equivalence point.',
      refs: [R.openstaxChem, yt('titration curve weak acid strong base pKa half equivalence', 'Video — Reading a titration curve')]
    },
    {
      id: 'vis-lever-01', exam: 'asvab', section: 'gs', difficulty: 'hard', type: 'entry',
      q: 'A uniform beam balances on a pivot. A 40 N weight sits 3.0 m to the left of the pivot. What force, in newtons, is needed 2.0 m to the right to balance it?',
      a: 60, tol: 0.5,
      why: '<p>A beam balances when the moments about the pivot are equal:</p>' +
        '<p><strong>force × distance = force × distance</strong></p>' +
        '<p>40 N × 3.0 m = F × 2.0 m, so 120 = 2F, giving <strong>F = 60 N</strong>.</p>' +
        '<p>Sanity check the direction before you commit: the unknown sits <em>closer</em> to the pivot, so it must be <em>larger</em>. Any answer below 40 N is wrong on inspection — and 26.7 N, from dividing the wrong way round, is the distractor this is built around.</p>',
      visual: svgLever, caption: 'Moments balance about the pivot: 40 N × 3.0 m = F × 2.0 m.',
      refs: [R.openstaxPhys, yt('moments principle of moments lever balance physics', 'Video — The principle of moments')]
    },

    /* ---- maths graphs and charts ---- */
    {
      id: 'vis-linear-01', exam: 'math-placement', section: 'algebra', difficulty: 'moderate', type: 'mcq',
      q: 'A line passes through (0, 1) and rises 2 units for every 1 unit it moves right. Its equation is:',
      opts: ['y = x + 2', 'y = 2x + 1', 'y = 2x − 1', 'y = ½x + 1'],
      a: 1,
      why: '<p>Slope-intercept form is <strong>y = mx + b</strong>, where m is the slope and b the y-intercept.</p>' +
        '<p>Slope = rise ÷ run = 2 ÷ 1 = <strong>2</strong>. The line crosses the y-axis at (0, 1), so <strong>b = 1</strong>.</p>' +
        '<p>That gives <strong>y = 2x + 1</strong>. Option A swaps slope and intercept — the most common error — and option D inverts the rise-over-run ratio.</p>',
      visual: svgLinear, caption: 'Slope is rise over run; the y-intercept is where the line crosses x = 0.',
      refs: [R.openstaxAlg, R.khan]
    },
    {
      id: 'vis-bar-01', exam: 'ati-teas', section: 'math', difficulty: 'moderate', type: 'entry',
      q: 'Using the bar chart, what is the mean number of units sold per day across the five days?',
      a: 21, tol: 0.1,
      why: '<p>Read each bar against the axis: Mon 20, Tue 35, Wed 15, Thu 25, Fri 10.</p>' +
        '<p>Total = 20 + 35 + 15 + 25 + 10 = <strong>105</strong>. Divide by 5 days: <strong>21 units per day</strong>.</p>' +
        '<p>Note the mean (21) sits above the median (20) here, pulled up by Tuesday\'s 35. On chart-reading items, check the axis interval before reading values — a gridline worth 10 rather than 5 changes every figure.</p>',
      visual: svgBar, caption: 'Read each bar against the axis before calculating.',
      refs: [R.openstaxStat, yt('reading bar charts mean median data interpretation', 'Video — Interpreting bar charts')]
    },
    {
      id: 'vis-normal-01', exam: 'nln-nex', section: 'math', difficulty: 'hard', type: 'entry',
      q: 'Scores are normally distributed with a mean of 500 and a standard deviation of 100. Approximately what percentage of scores fall between 300 and 700? (Give the number only.)',
      a: 95, tol: 1,
      why: '<p>300 and 700 are each <strong>two standard deviations</strong> from the mean of 500 (500 ± 2 × 100).</p>' +
        '<p>By the empirical rule, about <strong>95%</strong> of a normal distribution lies within two standard deviations.</p>' +
        '<p>The full rule is worth memorising: <strong>68%</strong> within 1σ, <strong>95%</strong> within 2σ, <strong>99.7%</strong> within 3σ. Convert the raw values to how many standard deviations they sit from the mean first — the arithmetic after that is trivial.</p>',
      visual: svgNormal, caption: 'The empirical rule: 68%, 95% and 99.7% within one, two and three standard deviations.',
      refs: [R.openstaxStat, yt('empirical rule 68 95 99.7 normal distribution', 'Video — The empirical rule')]
    },
    {
      id: 'vis-normal-02', exam: 'gre', section: 'quant', difficulty: 'advanced', type: 'mcq',
      q: 'In a normal distribution, approximately what percentage of values lie ABOVE one standard deviation above the mean?',
      opts: ['5%', '16%', '32%', '68%'],
      a: 1,
      why: '<p>68% lies <em>within</em> one standard deviation, leaving 32% in the two tails combined. The distribution is symmetric, so each tail holds half of that: <strong>16%</strong>.</p>' +
        '<p>32% is the trap — that is both tails together, not the upper one alone.</p>' +
        '<p>Sketch the curve and shade what the question asks for. On tail problems the arithmetic is easy; the errors come from shading the wrong region.</p>',
      visual: svgNormal, caption: 'Symmetry splits the remaining 32% evenly between the two tails.',
      refs: [R.openstaxStat, yt('normal distribution tail percentage standard deviation', 'Video — Tails of the normal curve')]
    }
  );

})();
